$(document).ready(function(){

    $("body").removeClass("preload");

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };

    //toggle for mobile navigation button
    $('.mobile-nav-toggle').click(function(){
        $('body').toggleClass('mobile-nav-open');
    });

    //toggle for rhs mobile navigation button
    $('.toggle-mini-dropdown').click(function(){
        $('.mini-dropdown').toggleClass('hide');
    });

    //toggle for explore nav on desktop
    if($(window).width() > 992){
        $(".hamburger.nav-toggle").click(function() {
            if($('body').hasClass('exploring')){
                setTimeout(function(){
                    $(".explore-nav").slideToggle(250);
                }, 250);
                $(this).removeClass('is-active');
            }else{
                $(".explore-nav").slideToggle(250);
                $(this).addClass('is-active');
            }
            $("body").toggleClass("exploring");
        });
    }else{
        $(".hamburger.nav-toggle").click(function() {
            if($('body').hasClass('exploring')){
                $(this).removeClass('is-active');
            }else{
                $(this).addClass('is-active');
            }
            $("body").toggleClass("exploring");
        });
        $(".group-title").click(function() {
            $(this).parent('.explore-group').toggleClass('open').find('ul').slideToggle();
        });
    }

    //initialize all materialize select boxes
    $("select:not(.vue-select):not(.ql-header):not(.ql-color):not(.ql-background)").material_select();
    document.querySelectorAll('.select-wrapper').forEach(t => t.addEventListener('click', e=>e.stopPropagation()))


    function determineColor(){

        var rgb = $(".background-color-determiner").css("backgroundColor");
        var colors = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        var brightness = 1;

        var r = colors[1];
        var g = colors[2];
        var b = colors[3];        
        
        var o = Math.round(((parseInt(r) * 299) + (parseInt(g) * 587) + (parseInt(b) * 114)) /1000);
        
        if(o > 125) {
            $('.text-color-change').addClass('white-text').removeClass('black');
        }else{ 
            $('.text-color-change').addClass('white-text').removeClass('black');
        }      
    }

    if ($(".background-color-determiner").length){
        determineColor();
    } 

    //generating pdf
    $(".generate-pdf-button").click(function(){
        $(this).text('Generating, Please Wait...');
    });

    //
    $(".modal").modal();

    $("#modalScore").click(function(){
        $('.pricing-modal-container').fadeIn(250);
    });

    $(".pricing-modal-container .close").click(function(){
        $('.pricing-modal-container').fadeOut(250);
    });

    if($('#modal-view-limit-count').length){
        $('body').css({'overflow':'hidden'});
    }

    //tooltips
    $(document).ready(function() {
      $(".tooltipped").tooltip();
    });

    //character counter
    function charactersRemaining(el){
        var parent = el.parents(".character-count");
        var count = el.val().length;
        var max = parent.attr("data-max");
        var remaining = max - count;
        parent.find(".count").text(remaining);
    }

    $(".character-count textarea, .character-count input").on("input", function() {
        charactersRemaining($(this));
    });

    $(".character-count").each(function(){
        if ($(this).find("textarea").length){
            charactersRemaining($(this).find("textarea"));
        } 
        if ($(this).find("input").length) {
            charactersRemaining($(this).find("input"));
        } 
    });

    //AD CLICK


    $('.card-promotion').click(function(e){
        var id = $(this).attr('data-id');
        var data = {
            'id':id,
            'path': window.location.pathname
        };
        axios.post("/tracking/Ad", data)
        .then((response) =>  {
        }).catch(function (error) {
            console.log(error);
        });
    });

    //network nav

    function networkNavAttach(){
        var elem = document.querySelector('.network-list');
        if(elem){
            var bounding = elem.getBoundingClientRect();
            if (bounding.top < 20) {
                $('.university .header').css({'opacity':'0'});
            }else{
                $('.university .header').css({'opacity':'1'});
            }
            if (bounding.top < 0) {
                $('.network-uni-nav').css({'position':'fixed'});
            }else{
                $('.network-uni-nav').css({'position':'absolute'});
            }
        }
    }

    if($('body.network, body.university').length){
        networkNavAttach();

        $(window).scroll(function(){
            networkNavAttach();
        });
    }

    $('.network-uni-nav .mobile-nav').click(function(){
        $('.network-uni-nav').find('.container.lower:before')
            .stop(true, true)
            .animate({
                height:"toggle",
                opacity:"toggle"
            },250);

        $('.network-uni-nav').find('.container.lower ul')
            .stop(true, true)
            .animate({
                height:"toggle",
                opacity:"toggle"
            },250);
    });

    $('.dashboard-sidebar-toggle').click(function(){
        $('.dashboard-view').toggleClass('dashboard-sidebar-open');
    });

    function pullUpInnovationContainer(){
        if($(window).width() > 992){
            if($('#innovation-header').length){
                var height = $('#innovation-header .card-container').height();
                $('#innovation-header .card-container').css({'margin-top':'-'+height/2+'px'}).addClass('loaded');
            }
            if($('#user-header').length){
                var height = $('#user-header .card-container').height();
                $('#user-header .card-container').css({'margin-top':'-'+height/2+'px'}).addClass('loaded');
            }
        }else{
            if($('#innovation-header').length){
                var height = $('#innovation-header .card-container .card-image').outerHeight();
                $('#innovation-header .card-container').css({'margin-top':'-'+height/2+'px'}).addClass('loaded');
            }
            if($('#user-header').length){
                var height = $('#user-header .card-container').outerHeight();
                $('#user-header .card-container').css({'margin-top':'-'+height/2+'px'}).addClass('loaded');
            }
        }
    }

    pullUpInnovationContainer();

    if(window.location.hash == '#application-details' || window.location.hash == '#component-application-feedback'){
        $('[href="#application-details"]').click();
    }

    $(window).resize(function(){
        pullUpInnovationContainer();
    });
                    
    $('.tabs').tabs();

    if($('.currency-symbol').length){
        var ip = $('.currency-symbol').data('ip');
        $.getJSON('https://ipapi.co/'+ip+'/json', function(data){
            if(data && data.currency == 'EUR'){
                $('.currency-symbol').html('€');
            }else if(data && data.currency == 'GBP'){
                $('.currency-symbol').html('£');
            }else{
                $('.currency-symbol').html('US$');
            }
        });
    }

    if($('.actions-content').length){
        function articleActionsPosition(){
            let scrollTop = $(window).scrollTop()
            let elementOffset = 0
            if ($('#article-content').length) {
                elementOffset = $('#article-content').offset().top
            }
            let distance = (elementOffset - scrollTop);

            if(distance < 0){
                $('.actions-content').addClass('under');
            }else{
                $('.actions-content').removeClass('under');
            }
        }

        $(window).scroll(function(){
            articleActionsPosition();
        });

        articleActionsPosition();
    }

    if($('.page-about').length){
        $(".section--what-we-do .slides").slick({
            infinite: true,
            dots: true,
            fade: true,
            autoplay: true,
            autoplaySpeed: 10000,
            nextArrow: "<button type='button' class='slick-next'><i class='far fa-chevron-right'></i></button>"
        });

        $(".section--our-story .slides").slick({
            infinite: false,
            dots: true,
            fade: false,
            nextArrow: "<button type='button' class='slick-next'><i class='far fa-chevron-right'></i></button>"
        });
    }
    
    if($('.accordion').length){

        $(".accordion .accordion-title").click(function(){
            $(this).parent('.accordion').toggleClass('open');
            $(this).parent('.accordion').find('.accordion-text').slideToggle(500);
        });
    }

    $('.register #password, .reset-password-view #password, .user-editor #password').strength({
        strengthClass: 'strength',
        strengthMeterClass: 'strength_meter',
        strengthButtonClass: 'button_strength',
        strengthButtonText: 'Show password',
        strengthButtonTextToggle: 'Hide Password'
    });	

    $('.video-toggle.open').click(function(){
        $('.video-box').fadeToggle();
        var src = $('#videoEmbed iframe').attr('data-src');
        $('#videoEmbed iframe').attr('src', src);
    });

    $(".video-toggle.close").click(function() {
        $('.video-box').fadeToggle();
        $('#videoEmbed iframe').attr("src", "");
    });
});
